<template>
  <span @mousedown.stop.prevent="startMoving" @touchstart.stop.prevent="startTouchMoving">
    <slot />
  </span>
</template>

<script>
export default {
  data() {
    return {
      startPosition: null,
    };
  },
  methods: {
    startTouchMoving(event) {
      var { screenX, screenY } = event.touches[0]
      this.startMoving({ screenX, screenY });
    },
    startMoving(event) {
      this.startPosition = { x: event.screenX, y: event.screenY };
      this.$emit('drag-start', event)
    },
    touchMoving(event) {
      var { screenX, screenY } = event.changedTouches[0]
      this.moving({ screenX, screenY });
    },
    moving(event) {
      if (this.startPosition) {
        this.$emit('dragging', { x: event.screenX - this.startPosition.x, y: event.screenY - this.startPosition.y, });
      }
    },
    endTouchMoving(event) {
      var { screenX, screenY } = event.changedTouches[0]
      this.startMoving({ screenX, screenY });
    },
    endMoving(event) {
      if (this.startPosition) {
        this.$emit('drag-stop', { x: event.screenX - this.startPosition.x, y: event.screenY - this.startPosition.y, });
        this.startPosition = null;
      }
    },
  },
  mounted() {
    window.addEventListener('mousemove', this.moving);
    window.addEventListener('mouseup', this.endMoving);

    window.addEventListener('touchmove', this.touchMoving);
    window.addEventListener('touchend', this.endTouchMoving);
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.moving);
    window.removeEventListener('mouseup', this.endMoving);

    window.removeEventListener('touchmove', this.touchMoving);
    window.removeEventListener('touchend', this.endTouchMoving);
  },
}
</script>